import { chatCompletion, type InferenceTarget } from "../suite/inference";
import { parseGrokChecklist } from "./store";
import type { QaItem } from "./types";

export async function draftChecklistFromBrain(
  target: InferenceTarget,
  targetUrl: string,
): Promise<QaItem[]> {
  const content = await chatCompletion(
    target,
    [
      {
        role: "system",
        content:
          "You author Site QA checklists for AgentForge. " +
          "Return ONLY a JSON array. Each object: " +
          '{"id":"slug","title":"short visible check","actions":[{"type":"goto"|"click"|"type"|"expectText"|"expectVisible"|"wait",...}]}. ' +
          "Prefer expectText / expectVisible. No markdown, no commentary.",
      },
      {
        role: "user",
        content: `Website: ${targetUrl}\nWrite 6-12 boxes that prove the primary UI still works.`,
      },
    ],
    { temperature: 0.2, maxTokens: 1600 },
  );
  const json = content.replace(/^```(?:json)?\s*/i, "").replace(/\s*```$/, "");
  return parseGrokChecklist(json).items;
}
